'use client'

import React, { useEffect, useMemo, useRef, useState } from 'react'
import Image from 'next/image'
import ReplayIcon from '@public/image/home-icon-replay.png'
import { useBrowserDevices, useMediaQuery } from '@segway/core'
import { useInViewport } from 'ahooks'

// import Player from 'xgplayer'
import { Link } from '@/i18n/navigation'

import { HomeButton } from '../Button'
import { FloorType } from '../types'

import styles from './index.module.css'
interface PauseIconProps {
  data: FloorType
}

interface LinkCompProps {
  url: string
  children: React.ReactNode
}
// 修正类型定义
const LinkComp = ({ url, children }: LinkCompProps) => {
  return url ? <Link href={url}>{children}</Link> : children
}
const ProductBanner = ({ data }: PauseIconProps) => {
  const { isChrome, isSafari } = useBrowserDevices()

  const [isPlaying, setIsPlaying] = useState(false)
  const [isEnd, setIsEnd] = useState(true)
  const videoRef = useRef<HTMLVideoElement>(null)
  const responsive = useMediaQuery()
  const elementRef = useRef<HTMLDivElement>(null)
  const [isInView] = useInViewport(elementRef)

  const isXlScreen = responsive && responsive.xl
  const isMdScreen = responsive && responsive.md
  const isXsScreen = responsive && responsive.xs

  const isShowVideo = useMemo(() => {
    if (isChrome || isSafari || (responsive && responsive.xl)) {
      return true
    }

    return false
  }, [isChrome, isSafari, responsive])

  const handleTogglePlay = () => {
    setIsPlaying((status) => !status)

    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause()
      } else {
        videoRef.current.play()
      }
    }
  }

  const calcTheme = () => {
    const theme = { text: '', bg: '', className: '' }
    if (data?.banner?.item_theme === 'dark') {
      theme.text =
        'max-xl:font-miSansMedium380 font-miSansDemiBold450 max-xl:text-[rgba(255, 255, 255, 1)] text-white'
      theme.bg = ''
      theme.className = `${styles.darkModeContainer} ${styles.darkModeBorder}`
    } else if (data?.banner?.item_theme === 'light') {
      theme.text = 'text-black'
      theme.bg = ''
      theme.className = `${styles.lightModeContainer} ${styles.lightModeBorder}`
    }
    return theme
  }

  useEffect(() => {
    if (videoRef.current) {
      if (isInView) {
        videoRef.current?.play()
      } else {
        if (videoRef.current?.currentTime) {
          videoRef.current.currentTime = 0
        }
        videoRef.current?.pause()
      }
    }
  }, [isInView])

  const getActionBtnState = () => {
    if (
      data?.banner?.product?.sku &&
      data?.banner?.button_text &&
      data?.banner?.button_text !== ''
    ) {
      return {
        isActionBtnVisible: true,
        actionBtnText: data?.banner?.button_text,
      }
    }

    if (
      data?.banner?.product?.sku &&
      (!data?.banner?.button_text || data?.banner?.button_text === '')
    ) {
      return {
        isActionBtnVisible: true,
        actionBtnText: `$${data?.banner?.product?.final_price}`,
      }
    }

    return {
      isActionBtnVisible: false,
      actionBtnText: '',
    }
  }

  const { actionBtnText, isActionBtnVisible } = getActionBtnState()

  return (
    <div className="flex w-full justify-center max-md:aspect-square">
      <div className="relative w-full">
        <LinkComp url={data?.banner?.button_link}>
          <div className="relative flex h-[343px] w-[343px] items-center gap-[10px] overflow-hidden rounded-[12px] bg-gray-200 max-xl:h-[271px] max-xl:w-full max-xl:items-start max-md:h-full max-md:w-full xl:h-[576px] xl:w-full xl:rounded-[20px]">
            {data?.banner?.pc_image ? (
              <div className="absolute h-[100%] w-[100%]" ref={elementRef}>
                {isXlScreen ? (
                  <Image
                    src={data?.banner?.pc_image}
                    className="h-[100%] w-[100%] object-cover"
                    fill
                    alt=""
                  />
                ) : isMdScreen ? (
                  <Image
                    src={data?.banner?.pad_image ?? data?.banner?.pc_image}
                    className="h-[100%] w-[100%] object-cover"
                    fill
                    alt=""
                  />
                ) : (
                  <Image
                    src={data?.banner?.mob_image}
                    className="h-[100%] w-[100%] object-cover"
                    fill
                    alt=""
                  />
                )}
                {(isXlScreen || isMdScreen) && data?.banner?.video_url && isShowVideo ? (
                  <>
                    <video
                      ref={videoRef}
                      poster={data?.banner.pc_image}
                      src={data?.banner?.video_url}
                      muted
                      playsInline
                      controlsList="nopictureinpicture"
                      onPause={() => setIsPlaying(false)}
                      onPlay={() => {
                        setIsPlaying(true)
                        setIsEnd(false)
                      }}
                      onEnded={() => {
                        setIsEnd(true)
                        if (videoRef.current) {
                          videoRef.current.currentTime = 0
                        }
                      }}
                      className={`relative h-[100%] w-[100%] object-cover ${isEnd ? 'opacity-0' : ''}`}></video>
                  </>
                ) : null}
                {isXsScreen && data?.banner?.video_url_mob && isShowVideo ? (
                  <>
                    <video
                      ref={videoRef}
                      poster={data?.banner.mob_image}
                      src={data?.banner?.video_url_mob}
                      muted
                      playsInline
                      controlsList="nopictureinpicture"
                      onPause={() => setIsPlaying(false)}
                      onPlay={() => {
                        setIsPlaying(true)
                        setIsEnd(false)
                      }}
                      onEnded={() => {
                        setIsEnd(true)
                        if (videoRef.current) {
                          videoRef.current.currentTime = 0
                        }
                      }}
                      className={`relative h-[100%] w-[100%] object-cover ${isEnd ? 'opacity-0' : ''}`}></video>
                  </>
                ) : null}
              </div>
            ) : null}
            <div className="relative flex flex-col max-xl:h-full max-xl:w-full max-xl:justify-between max-xl:py-[40px] max-xl:pl-[30px] max-xl:pr-[16px] max-md:py-[16px] max-md:pl-[16px] md:gap-[5px] xl:mt-[3px] xl:gap-[48px] xl:pl-[110px]">
              <div className="flex flex-col justify-center gap-[5px] text-[#fff] md:gap-1 xl:w-[800px] xl:gap-[8px]">
                {data?.banner?.subtitle ? (
                  <p className="items-center font-miSansDemiBold450 text-[22px] md:font-miSansMedium380 md:text-[20px] xl:font-miSansMedium380 xl:text-[20px]">
                    {data?.banner?.subtitle}
                  </p>
                ) : null}
                {data?.banner?.title && (
                  <p
                    className="mb-[5px] overflow-hidden text-ellipsis whitespace-nowrap font-miSansDemiBold450 text-[22px] leading-[1.2] md:font-miSansSemiBold520 md:text-[28px] xl:mb-0 xl:font-miSansSemiBold520 xl:text-[64px]"
                    title={data?.banner?.title}>
                    {data?.banner?.title}
                  </p>
                )}
                {data?.banner?.title_image && (
                  <div className="relative w-full self-start">
                    <Image
                      src={data?.banner?.title_image}
                      alt={data?.banner?.title || 'Banner title'}
                      className="h-auto max-h-[26px] w-auto max-w-full object-contain object-left xl:max-h-[77px]"
                      style={{ height: 'auto' }}
                      width={0}
                      height={0}
                      unoptimized
                      sizes="100vw"
                    />
                  </div>
                )}
                {data?.banner?.description ? (
                  <p className="hidden items-center text-[24px] leading-[1.4] md:font-miSansMedium380 md:text-[14px] xl:block xl:text-[24px]">
                    {data?.banner?.description}
                  </p>
                ) : null}
                {responsive &&
                !responsive.xl &&
                data?.banner?.product?.sku &&
                (!data?.banner?.button_text || data?.banner?.button_text === '') ? (
                  <div className="mt-[6px] font-miSansDemiBold450 text-[14px] leading-[22px] text-white">
                    <span className="mr-[3px] text-[12px] text-sm xl:text-[14px]">$</span>
                    {data?.banner?.product?.final_price}
                  </div>
                ) : null}
              </div>

              {/* features */}
              {data?.banner?.items?.length > 0 ? (
                <div
                  className={`${responsive && responsive.md ? 'max-w-[319px]' : ''} relative flex w-full flex-col items-center gap-[12px] self-start overflow-hidden rounded-[12px] px-[24px] py-[12px] text-[12px] max-xl:px-[14.5px] max-xl:py-[12px] xl:w-fit xl:max-w-[1330px] xl:flex-row xl:gap-[32px] xl:self-start xl:py-[20px] xl:pl-[24px] xl:text-[14px] ${calcTheme().text} ${calcTheme().className}`}>
                  {/* <div className="flex-shrink-0">
                    <Arrow width={30} height={30} color="#000" rotate={180} />
                  </div> */}
                  <div className="grid grid-cols-[auto_auto] justify-between max-xl:w-full max-xl:grid-cols-2 max-xl:gap-3 xl:gap-x-[32px] xl:gap-y-[20px]">
                    {data?.banner?.items.slice(0, 4).map((item, index) => (
                      <div className="flex items-center gap-[4px] xl:gap-[8px]" key={index}>
                        <Image src={item?.icon} width={16} height={16} alt="" />
                        <span
                          className={`${calcTheme().text} font-miSansRegular330 xl:font-miSansDemiBold450`}>
                          {item?.title}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ) : null}

              {/* button */}
              {isXlScreen && isActionBtnVisible ? (
                <div className="xl:flex">
                  <HomeButton className="flex h-[44px] w-[180px] justify-between !pl-[20px] !pr-[17px] text-white">
                    <span className="leading-[20px]">{actionBtnText}</span>{' '}
                  </HomeButton>
                </div>
              ) : null}
            </div>
          </div>
        </LinkComp>

        {data?.banner?.video_url && isXlScreen && isEnd ? (
          <span
            className="absolute bottom-[30px] right-[30px] flex h-[56px] w-[56px] cursor-pointer items-center justify-center overflow-hidden rounded-full"
            role="botton"
            tabIndex={0}
            onClick={() => {
              handleTogglePlay()
            }}>
            <Image fill src={ReplayIcon} alt={data?.banner?.title} />
          </span>
        ) : null}
      </div>
    </div>
  )
}

export default ProductBanner
